module.exports = __webpack_public_path__ + "img/wescot_roofing_website.a3eb7c9f.jpg";